import {Modal} from 'react-bootstrap';
import PolicyPDFViewer from '../PolicyPDFViewer';
import {useSelector} from 'react-redux';

const TermsAndConditionsModal = (props)=>{
  const hrMobileLanguage = useSelector((state) => state.app.slsHrMobileLanguage);

  return (
    <>
      <Modal
        show={props?.showModal}
        onHide={() => {
          props?.setShowModal(false);
        }}
        fullscreen={true}
      >
        <Modal.Header closeButton className='mt-2'>
          <Modal.Title>{hrMobileLanguage == 'en' ? 'Terms and Conditions' : 'ข้อกำหนดและเงื่อนไข'} </Modal.Title>
        </Modal.Header>
        <Modal.Body className='pb-0 pt-0'>
          <PolicyPDFViewer pdfUrl={`${process.env.PUBLIC_URL}/term-and-condition/terms-and-conditions-${hrMobileLanguage}.pdf`} />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default TermsAndConditionsModal;
